import { memo } from 'react';
import { useAppStore } from '../state/store';
import { BIMElementLayer } from '../views/BIMSceneContent';

/**
 * BIM shaded content layer — the cross-workbench replacement for the
 * wireframe BIMOverlayLayer cross-references.
 *
 * Mounts the SAME element renderer the BIM workbench uses (BIMElementLayer:
 * per-category renderers, wall CSG cache, instanced bulk, view materials) so
 * a wall drawn in BIM looks identical — shaded, hidden-line, wireframe... —
 * in every workbench, instead of line-art. Display style resolution:
 * - CAD/3D workbench + quad previews: the shared app view.viewMode (the same
 *   flag the ViewControlBar and the BIM viewport write).
 * - Sketch workbench: the sketch display style, mapped onto the BIM view
 *   modes by the caller (sketchStyleToViewMode) — the two enums are the same
 *   visual language.
 *
 * viewType is always '3d' here: plan-view cut semantics (hiddenLine forcing,
 * view-range clipping) belong to the BIM workbench's own views; the shared
 * viewports render model space. Visibility (Temporary Hide/Isolate, Reveal
 * Hidden, per-category gates) flows from the same shared view state, and the
 * unified picking contract (entity registry + entity-click router) is active
 * inside the layer for every workbench except BIM itself.
 */
export const BIMShadedLayer = memo(function BIMShadedLayer({ viewMode }: { viewMode?: string }) {
    const appViewMode = useAppStore((s) => s.view.viewMode);
    return <BIMElementLayer viewType="3d" viewMode={viewMode ?? appViewMode} />;
});
